<div
  class="group relative border-b border-slate-200 bg-white p-4 transition-all hover:bg-slate-50/30"
>
  <!-- Cabecera: Título y Acción rápida -->
  <div class="mb-3 flex items-start justify-between">
    <div class="min-w-0">
      <h3 class="truncate text-[15px] font-bold tracking-tight text-slate-800">
        {{ productoCarrito().nombre }}
      </h3>
      <div class="mt-0.5 flex items-center gap-2">
        <span
          class="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold text-slate-500 uppercase"
        >
          {{ productoCarrito().codigo }}
        </span>
        <span class="text-[11px] font-medium text-slate-400">
          Stock: <span class="text-slate-600">{{ productoCarrito().stock }}</span>
        </span>
      </div>
    </div>

    <button
      (click)="eliminarProducto()"
      class="flex h-8 w-8 items-center justify-center rounded-full transition-all hover:bg-red-200 text-red-500 active:scale-90"
    >
      <i class="bi bi-trash3 text-lg"></i>
    </button>
  </div>

  <!-- Zona de Controles y Total -->
  <div class="flex items-center gap-4">
    <!-- Contenedor de Inputs con fondo integrado -->
    <div
      class="flex flex-1 items-center gap-3 rounded-2xl bg-slate-50 p-1.5 ring-1 ring-inset ring-slate-100"
    >
      <!-- Cantidad -->
      <div class="flex flex-1 flex-col items-center gap-0.5 border-r border-slate-200/60">
        <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Cant.</span>
        <app-input-count [(cantidad)]="productoCarrito().cantidad" [min]="1" />
      </div>

      <!-- Precio -->
      <div class="flex flex-1 flex-col items-center gap-0.5">
        <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Precio</span>
        <app-input-count
          [(cantidad)]="productoCarrito().precio"
          [min]="1"
          [step]="0.1"
          [decimal]="true"
        />
      </div>
    </div>

    <!-- Total resaltado (El protagonista) -->
    <div class="flex flex-col items-end min-w-21.25">
      <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Subtotal</span>
      <div class="flex items-baseline gap-0.5 text-blue-600">
        <span class="text-xs font-bold">S/.</span>
        <span class="text-lg font-black leading-none tracking-tight">
          {{ precioTotal() | currency: 'PEN' : '' }}
        </span>
      </div>
    </div>
  </div>
</div>
